// extracted by mini-css-extract-plugin
export var loading = "ReviewsModule-module--loading--61cf5";
export var reviewsContainer = "ReviewsModule-module--reviewsContainer--7426c";